export default (search: string, keyword: string) => new URLSearchParams(search).get(keyword);
